module.exports = __webpack_public_path__ + "static/media/ExamBankLock.474d8c45.svg";